import { INVALIDATE_FACTURES } from 'actions/invalidationTags';
import { ApiMananger } from 'actions/rtkquery';
import { FACTURATION_API_ROUTE } from 'routes/api/endpoints';

const facturationApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    getFactures: build.query({
      query: ({ dossier_id, type, statut }) => {
        let url = `${FACTURATION_API_ROUTE}?dossier_id=${dossier_id}&page=1&page_size=200`;
        if (type) url += `&type=${type}`;
        if (statut) url += `&statut=${encodeURIComponent(statut)}`;
        return url;
      },
      providesTags: [INVALIDATE_FACTURES],
    }),
    getFactureById: build.query({
      query: ({ id, dossier_id }) =>
        `${FACTURATION_API_ROUTE}${id}/?dossier_id=${dossier_id}`,
      providesTags: [INVALIDATE_FACTURES],
    }),
  }),
});

export const { useGetFacturesQuery, useGetFactureByIdQuery } = facturationApi;
